// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const MAX_LENGTH = 254;
// Same shape as the generic validator, but the top-level domain must be
// alphabetic and have at least two characters, so `user@example.c` is rejected.
const MY_EMAIL_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/;

export function validateMalaysianCustomerEmail(emailValue: string): ?UserInputValidationError {
  const email = emailValue || '';

  if (!email.trim()) {
    return { id: 'empty' };
  }

  if (email.length > MAX_LENGTH || !MY_EMAIL_PATTERN.test(email.toLowerCase())) {
    return { id: 'invalid-email' };
  }
}
